import styled, { css } from 'styled-components'

import { ReactComponent as ResetIcon } from '@sketch/icons/arrow-clockwise-17'
import { ReactComponent as FilterIconSvg } from '@sketch/icons/3-lines-filter-24'
import { ReactComponent as Divider } from '@sketch/icons/divider-vertical-2'

import {
  Checkbox,
  ButtonUnstyled,
  Dropdown,
  Navbar,
  MenuIconButton,
} from '@sketch/components'

export const StyledCheckbox = styled(Checkbox)`
  cursor: pointer;
  padding: 8px 12px 8px 12px;
`

export const StyledDropdownItem = styled(Dropdown.Item)`
  padding: 0;
`

export const Filter = styled(Navbar.Filter)`
  input[type='search'] {
    /* Padding right includes the clear button and the options button */
    padding-right: 32px; /* stylelint-disable-line scales/space */
    outline-offset: -4px; /* To avoid cutting focus ring */
  }
`

export const StyledDropdownHeader = styled(Dropdown.Header)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  pointer-events: auto;
`

export const IconButton = styled(ButtonUnstyled)`
  cursor: pointer;
`

export const StyledResetIcon = styled(ResetIcon)<{ $active: boolean }>`
  width: 17px;
  height: 17px;
  color: ${({ $active, theme }) =>
    $active
      ? theme.colors.foreground.secondary.A
      : theme.colors.state.disabled};
`

export const FilterMenuIconButton = styled(MenuIconButton)<{
  $highlighted?: boolean
}>`
  ${({ $highlighted, theme }) =>
    $highlighted &&
    css`
      && [role='img'] {
        color: ${theme.colors.sketch.A};
        opacity: 1;
      }
    `}
`

export const FilterIcon = styled(FilterIconSvg)`
  height: 24px;
  width: 24px;
`

export const StyledDivider = styled(Divider)`
  width: 2px;
  flex-shrink: 0;
`
